module.exports = function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var o = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
  }

  return n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {
      configurable: !1,
      enumerable: !0,
      get: r
    });
  }, n.r = function (e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, "a", t), t;
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.p = "", n(n.s = 8);
}([function (e, t, n) {
  e.exports = n(6)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, n) {
  e.exports = function (e, t) {
    var n = ["abcdefghijklmnopqrstuvwxyz", "ABCDEFGHIJKLMNOPQRSTUVWXYZ", "0123456789", "~!@#$%^&()_+-={}[];',"],
        r = "";
    (t = t || "aA0").split("").forEach(function (e) {
      isNaN(parseInt(e)) ? /[a-z]/.test(e) ? r += n[0] : /[A-Z]/.test(e) ? r += n[1] : r += n[3] : r += n[2];
    }), e = e || 30;

    for (var o = ""; e--;) {
      o += r.charAt(Math.floor(Math.random() * r.length));
    }

    return o;
  };
}, function (e, t, n) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, n) {
  "use strict";

  var r = function r(e) {};

  e.exports = function (e, t, n, o, i, s, a, u) {
    if (r(t), !e) {
      var c;
      if (void 0 === t) c = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {
        var p = [n, o, i, s, a, u],
            l = 0;
        (c = new Error(t.replace(/%s/g, function () {
          return p[l++];
        }))).name = "Invariant Violation";
      }
      throw c.framesToPop = 1, c;
    }
  };
}, function (e, t, n) {
  "use strict";

  function r(e) {
    return function () {
      return e;
    };
  }

  var o = function o() {};

  o.thatReturns = r, o.thatReturnsFalse = r(!1), o.thatReturnsTrue = r(!0), o.thatReturnsNull = r(null), o.thatReturnsThis = function () {
    return this;
  }, o.thatReturnsArgument = function (e) {
    return e;
  }, e.exports = o;
}, function (e, t, n) {
  "use strict";

  var r = n(5),
      o = n(4),
      i = n(3);

  e.exports = function () {
    function e(e, t, n, r, s, a) {
      a !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var n = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t
    };
    return n.checkPropTypes = r, n.PropTypes = n, n;
  };
}, function (e, t, n) {
  "use strict";

  n.r(t);

  var r = n(1),
      o = n.n(r),
      i = n(0),
      s = n.n(i),
      a = n(2),
      u = n.n(a),
      c = function () {
    function e(e, t) {
      for (var n, r = 0; r < t.length; r++) {
        (n = t[r]).enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
      }
    }

    return function (t, n, r) {
      return n && e(t.prototype, n), r && e(t, r), t;
    };
  }();

  var p = function (e) {
    function t(e) {
      !function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t);

      var n = function (e, t) {
        if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t;
      }(this, (t.__proto__ || Object.getPrototypeOf(t)).call(this, e));

      l.call(n);
      var r = n.props,
          o = r.isResponsive,
          i = r.startAt,
          s = r.endAt,
          a = r.fps,
          c = r.steps,
          p = r.direction;
      return n.id = "react-responsive-spritesheet--" + u()(8), n.spriteEl = n.spriteElContainer = n.spriteElMove = n.imageSprite = n.cols = n.rows = null, n.intervalSprite = !1, n.isResponsive = o, n.startAt = n.setStartAt(i), n.endAt = n.setEndAt(s), n.fps = a, n.steps = c, n.completeLoopCicles = 0, n.isPlaying = !1, n.spriteScale = 1, n.direction = n.setDirection(p), n.frame = n.startAt ? n.startAt : "rewind" === n.direction ? n.steps - 1 : 0, n;
    }

    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
    }(t, r["Component"]), c(t, [{
      key: "componentDidMount",
      value: function value() {
        this.init();
      }
    }, {
      key: "componentWillUnmount",
      value: function value() {
        window.removeEventListener("resize", this.resize);
      }
    }, {
      key: "setFps",
      value: function value(e) {
        this.fps = e, this.setIntervalPlayFunctions();
      }
    }, {
      key: "setInstance",
      value: function value() {
        return {
          play: this.play,
          pause: this.pause,
          goToAndPlay: this.goToAndPlay,
          goToAndPause: this.goToAndPause,
          setStartAt: this.setStartAt,
          setEndAt: this.setEndAt,
          setFps: this.setFps,
          setDirection: this.setDirection,
          getInfo: this.getInfo
        };
      }
    }, {
      key: "render",
      value: function value() {
        return this.renderElements();
      }
    }]), t;
  }(),
      l = function l() {
    var e = this;
    this.renderElements = function () {
      var t = e.props,
          n = t.image,
          r = t.className,
          i = t.style,
          s = t.widthFrame,
          a = t.heightFrame,
          u = t.background,
          c = t.backgroundSize,
          p = t.backgroundRepeat,
          l = t.backgroundPosition,
          f = t.onClick,
          d = t.onDoubleClick,
          h = t.onMouseMove,
          m = t.onMouseEnter,
          g = t.onMouseLeave,
          v = t.onMouseOver,
          y = t.onMouseOut,
          b = t.onMouseDown,
          w = t.onMouseUp,
          E = {
        position: "relative",
        overflow: "hidden",
        width: s + "px",
        height: a + "px",
        transform: "scale(" + e.spriteScale + ")",
        transformOrigin: "0 0",
        backgroundImage: "url(" + u + ")",
        backgroundSize: c,
        backgroundRepeat: p,
        backgroundPosition: l
      },
          I = o.a.createElement("div", {
        className: "react-responsive-spritesheet-container__move",
        style: {
          overflow: "hidden",
          backgroundRepeat: "no-repeat",
          display: "table-cell",
          backgroundImage: "url(" + n + ")",
          width: s + "px",
          height: a + "px",
          transformOrigin: "0 50%"
        }
      }),
          P = o.a.createElement("div", {
        className: "react-responsive-spritesheet-container",
        style: E
      }, I);
      return o.a.createElement("div", {
        className: "react-responsive-spritesheet " + e.id + " " + r,
        style: i,
        onClick: function onClick() {
          return f(e.setInstance());
        },
        onDoubleClick: function onDoubleClick() {
          return d(e.setInstance());
        },
        onMouseMove: function onMouseMove() {
          return h(e.setInstance());
        },
        onMouseEnter: function onMouseEnter() {
          return m(e.setInstance());
        },
        onMouseLeave: function onMouseLeave() {
          return g(e.setInstance());
        },
        onMouseOver: function onMouseOver() {
          return v(e.setInstance());
        },
        onMouseOut: function onMouseOut() {
          return y(e.setInstance());
        },
        onMouseDown: function onMouseDown() {
          return b(e.setInstance());
        },
        onMouseUp: function onMouseUp() {
          return w(e.setInstance());
        }
      }, P);
    }, this.init = function () {
      var t = e.props,
          n = t.image,
          r = t.widthFrame,
          o = t.heightFrame,
          i = t.autoplay,
          s = t.getInstance,
          a = t.onInit,
          u = new Image();
      u.src = n, u.onload = function () {
        if (document && document.querySelector("." + e.id)) {
          e.imageSprite = u, e.cols = e.imageSprite.width === r ? 1 : e.imageSprite.width / r, e.rows = e.imageSprite.height === o ? 1 : e.imageSprite.height / o, e.spriteEl = document.querySelector("." + e.id), e.spriteElContainer = e.spriteEl.querySelector(".react-responsive-spritesheet-container"), e.spriteElMove = e.spriteElContainer.querySelector(".react-responsive-spritesheet-container__move"), e.resize(!1), window.addEventListener("resize", e.resize), e.moveImage(!1), setTimeout(function () {
            e.resize(!1);
          }, 10), !1 !== i && e.play(!0);
          var t = e.setInstance();
          s(t), a(t);
        }
      }, u.onerror = function () {
        throw new Error("Failed to load image " + u.src);
      };
    }, this.resize = function () {
      var t = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0],
          n = e.props,
          r = n.widthFrame,
          o = n.onResize;
      e.isResponsive && (e.spriteScale = e.spriteEl.offsetWidth / r, e.spriteElContainer.style.transform = "scale(" + e.spriteScale + ")", e.spriteEl.style.height = e.getInfo("height") + "px", t && o && o(e.setInstance()));
    }, this.play = function () {
      var t = 0 < arguments.length && void 0 !== arguments[0] && arguments[0],
          n = e.props,
          r = n.onPlay,
          o = n.timeout;
      e.isPlaying || setTimeout(function () {
        r(e.setInstance()), e.setIntervalPlayFunctions(), e.isPlaying = !0;
      }, t ? o : 0);
    }, this.setIntervalPlayFunctions = function () {
      e.intervalSprite && clearInterval(e.intervalSprite), e.intervalSprite = setInterval(function () {
        e.isPlaying && e.moveImage();
      }, 1e3 / e.fps);
    }, this.moveImage = function () {
      var t = !(0 < arguments.length && void 0 !== arguments[0]) || arguments[0],
          n = e.props,
          r = n.onEnterFrame,
          o = n.onEachFrame,
          i = n.loop,
          s = n.onLoopComplete,
          a = Math.floor(e.frame / e.cols),
          u = e.frame - e.cols * a;
      e.spriteElMove.style.backgroundPosition = "-" + e.props.widthFrame * u + "px -" + e.props.heightFrame * a + "px", r && r.map(function (t) {
        t.frame === e.frame && t.callback && t.callback();
      }), t && ("rewind" === e.direction ? e.frame -= 1 : e.frame += 1, o && o(e.setInstance())), e.isPlaying && ("forward" === e.direction && (e.frame === e.steps || e.frame === e.endAt) || "rewind" === e.direction && (-1 === e.frame || e.frame === e.endAt)) && (i ? (s && s(e.setInstance()), e.completeLoopCicles += 1, e.frame = e.startAt ? e.startAt : "rewind" === e.direction ? e.steps - 1 : 0) : e.pause());
    }, this.pause = function () {
      var t = e.props.onPause;
      e.isPlaying = !1, clearInterval(e.intervalSprite), t(e.setInstance());
    }, this.goToAndPlay = function (t) {
      e.frame = t || e.frame, e.play();
    }, this.goToAndPause = function (t) {
      e.pause(), e.frame = t || e.frame, e.moveImage();
    }, this.setStartAt = function (t) {
      return e.startAt = t ? t - 1 : 0, e.startAt;
    }, this.setEndAt = function (t) {
      return e.endAt = t, e.endAt;
    }, this.setDirection = function (t) {
      return e.direction = "rewind" === t ? "rewind" : "forward", e.direction;
    }, this.getInfo = function (t) {
      switch (t) {
        case "direction":
          return e.direction;

        case "frame":
          return e.frame;

        case "fps":
          return e.fps;

        case "steps":
          return e.steps;

        case "width":
          return e.spriteElContainer.getBoundingClientRect().width;

        case "height":
          return e.spriteElContainer.getBoundingClientRect().height;

        case "scale":
          return e.spriteScale;

        case "isPlaying":
          return e.isPlaying;

        case "isPaused":
          return !e.isPlaying;

        case "completeLoopCicles":
          return e.completeLoopCicles;

        default:
          throw new Error("Invalid param `" + t + "` requested by Spritesheet.getinfo(). See the documentation on https://github.com/danilosetra/react-responsive-spritesheet");
      }
    };
  };

  p.propTypes = {
    className: s.a.string,
    style: s.a.object,
    image: s.a.string.isRequired,
    widthFrame: s.a.number.isRequired,
    heightFrame: s.a.number.isRequired,
    isResponsive: s.a.bool,
    steps: s.a.number.isRequired,
    fps: s.a.number.isRequired,
    direction: s.a.string,
    timeout: s.a.number,
    autoplay: s.a.bool,
    loop: s.a.bool,
    startAt: s.a.number,
    endAt: s.a.oneOfType([s.a.oneOf([!1]), s.a.number]),
    background: s.a.string,
    backgroundSize: s.a.string,
    backgroundRepeat: s.a.string,
    backgroundPosition: s.a.string,
    getInstance: s.a.func,
    onClick: s.a.func,
    onDoubleClick: s.a.func,
    onMouseMove: s.a.func,
    onMouseEnter: s.a.func,
    onMouseLeave: s.a.func,
    onMouseOver: s.a.func,
    onMouseOut: s.a.func,
    onMouseDown: s.a.func,
    onMouseUp: s.a.func,
    onInit: s.a.func,
    onResize: s.a.oneOfType([s.a.oneOf([!1]), s.a.func]),
    onPlay: s.a.func,
    onPause: s.a.func,
    onLoopComplete: s.a.oneOfType([s.a.oneOf([!1]), s.a.func]),
    onEachFrame: s.a.oneOfType([s.a.oneOf([!1]), s.a.func]),
    onEnterFrame: s.a.oneOfType([s.a.oneOf([!1]), s.a.array])
  }, p.defaultProps = {
    className: "",
    style: {},
    isResponsive: !0,
    direction: "forward",
    timeout: 0,
    autoplay: !0,
    loop: !1,
    startAt: 0,
    endAt: !1,
    background: "",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "",
    getInstance: function getInstance() {},
    onClick: function onClick() {},
    onDoubleClick: function onDoubleClick() {},
    onMouseMove: function onMouseMove() {},
    onMouseEnter: function onMouseEnter() {},
    onMouseLeave: function onMouseLeave() {},
    onMouseOver: function onMouseOver() {},
    onMouseOut: function onMouseOut() {},
    onMouseDown: function onMouseDown() {},
    onMouseUp: function onMouseUp() {},
    onInit: function onInit() {},
    onResize: !1,
    onPlay: function onPlay() {},
    onPause: function onPause() {},
    onLoopComplete: !1,
    onEachFrame: !1,
    onEnterFrame: !1
  }, t.default = p;
}, function (e, t, n) {
  e.exports = n(7);
}]);